import { AxiosInstance } from 'axios';
import { BaseRequestEndpoints } from '@trukt/types/BaseRequestEndpoints';
import {
  VendorSearchRequest,
  VendorSearchResponse,
  VendorCreateRequest,
  VendorCreateResponse,
  VendorUpdateRequest,
  VendorUpdateResponse,
  VendorDeleteRequest,
  VendorDeleteResponse,
  VendorGetRequest,
  VendorGetResponse,
} from './VendorServices.types';

import { VendorContactServices } from './services';

export class VendorServices implements BaseRequestEndpoints {
  instance: AxiosInstance;
  contact: VendorContactServices;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
    this.contact = new VendorContactServices(instance);
  }

  search(request: VendorSearchRequest) {
    return this.instance.get<VendorSearchResponse>('/vendors', {
      params: request.queryParams,
    });
  }

  getById(request: VendorGetRequest) {
    return this.instance.get<VendorGetResponse>(`/vendors/${request.routeParams.id}`);
  }

  create(request: VendorCreateRequest) {
    return this.instance.post<VendorCreateResponse>('/vendors', request.body);
  }

  update(request: VendorUpdateRequest) {
    return this.instance.put<VendorUpdateResponse>(
      `/vendors/${request.routeParams.id}`,
      request.body,
    );
  }

  delete(request: VendorDeleteRequest) {
    return this.instance.delete<VendorDeleteResponse>(`/vendors/${request.routeParams.id}`);
  }
}
